function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledButtonImageTagsGridComponent } from "./button-image-tags-grid-component.scss";
import ButtonImageTag from "./components/button-image-tag/button-image-tag";
class ButtonImageTagsGridComponent extends PureComponent {
    renderButtonTags() {
        const { gridButtonTags, isOpenLinkInNewTab } = this.props;
        return gridButtonTags.map((buttonTag, index)=>{
            return /*#__PURE__*/ _jsx("li", {
                className: "grid-button-container",
                children: /*#__PURE__*/ _jsx(ButtonImageTag, _object_spread_props(_object_spread({}, buttonTag), {
                    isOpenLinkInNewTab: isOpenLinkInNewTab
                }))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledButtonImageTagsGridComponent, {
            className: "button-image-tags-grid-component",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "grid-button-list",
                children: this.renderButtonTags()
            })
        });
    }
}
export { ButtonImageTagsGridComponent as default };
ButtonImageTagsGridComponent.defaultProps = {
    isOpenLinkInNewTab: true,
    gridButtonTags: [
        {
            tagImg: {
                src: "/static/img/tags/dashboards.png"
            },
            tagText: "Dashboards"
        },
        {
            tagImg: {
                src: "/static/img/tags/integrations.png"
            },
            tagText: "Integrations"
        },
        {
            tagImg: {
                src: "/static/img/tags/forms.png"
            },
            tagText: "Forms"
        },
        {
            tagImg: {
                src: "/static/img/tags/calendar_view.png"
            },
            tagText: "Calendar View"
        },
        {
            tagImg: {
                src: "/static/img/tags/automations.png"
            },
            tagText: "Automations"
        },
        {
            tagImg: {
                src: "/static/img/tags/timeline.png"
            },
            tagText: "Timeline View"
        },
        {
            tagImg: {
                src: "/static/img/tags/kanban.png"
            },
            tagText: "Kanban View"
        },
        {
            tagImg: {
                src: "/static/img/tags/notifications.png"
            },
            tagText: "Notifications"
        },
        {
            tagImg: {
                src: "/static/img/tags/workload.png"
            },
            tagText: "Workload"
        },
        {
            tagImg: {
                src: "/static/img/tags/subitems.png"
            },
            tagText: "Subitems (In beta)"
        },
        {
            tagImg: {
                src: "/static/img/tags/updates.png"
            },
            tagText: "Updates"
        },
        {
            tagImg: {
                src: "/static/img/tags/mapview.png"
            },
            tagText: "Map View"
        },
        {
            tagImg: {
                src: "/static/img/tags/guests.png"
            },
            tagText: "Guests Permissions"
        },
        {
            tagImg: {
                src: "/static/img/tags/timetracking.png"
            },
            tagText: "Time Tracking"
        },
        {
            tagImg: {
                src: "/static/img/tags/filesharing.png"
            },
            tagText: "File Sharing"
        },
        {
            tagImg: {
                src: "/static/img/tags/workspaces.png"
            },
            tagText: "Workspaces"
        }
    ]
};
